import { gql } from "@apollo/client";

export const GET_VERSION = gql`
query getVersions($platformtype: PlatformType) {
  allVersions(filter: {platformType: {equalTo: $platformtype}}) {
    nodes {
      appName
      appVersion
      createdAt
      deletedAt
      isForceUpdate
      platformType
      vId
      updatedAt
    }
    totalCount
  }
}
`;
